export const REVIEW_EDITABLE_TYPES = Object.freeze([
  'teacher-comment',
  'next-steps',
  'help-at-home',
  'principal-comment',
  'progress-visual',
  'strand-visual',
  'effort',
  'progress-descriptor',
]);
